import {utils} from '@wallaby-ui/core';

import * as Filters from './filters';
import {
  FILTER_TYPE_BOOL,
  FILTER_TYPE_DATE_MONTH,
  FILTER_TYPE_DATE_MONTH_RANGE,
  FILTER_TYPE_DATE_ONLY_RANGE,
  FILTER_TYPE_DATE_RANGE,
  FILTER_TYPE_FULLTEXT,
  FILTER_TYPE_HIERARCHY,
  FILTER_TYPE_HIERARCHY_MULTI_SELECT,
  FILTER_TYPE_MULTI_SELECT,
  FILTER_TYPE_MULTI_SELECT_ASYNC,
  FILTER_TYPE_NUMBER,
  FILTER_TYPE_NUMBER_RANGE,
  FILTER_TYPE_ORGANIZATION,
  FILTER_TYPE_AGENS,
  FILTER_TYPE_RADIO,
  FILTER_TYPE_SELECT,
  FILTER_TYPE_SELECT_ASYNC,
  FILTER_TYPE_TEXT,
  FILTER_TYPE_UNKNOWN,
  FILTER_TYPE_SELECT_ENUM,
  FILTER_TYPE_MULTI_SELECT_ENUM,
  FILTER_TYPE_RADIO_ENUM,
  FILTER_TYPE_MEDICATIONS,
} from './filters_definitions_constants';
import {LIBRARY_NAME} from 'src/js/common/constants';

const logger = utils.LogUtils.getLogger('FiltersDefinitions', LIBRARY_NAME);

const FiltersDefinitions = {
  [FILTER_TYPE_BOOL]: {
    filterName: 'BoolFilter',
    filterClass: Filters.BoolFilter,
  },
  [FILTER_TYPE_FULLTEXT]: {
    filterName: 'TextFilter',
    filterClass: Filters.TextFilter,
  },
  [FILTER_TYPE_DATE_RANGE]: {
    filterName: 'DateRangeFilter',
    filterClass: Filters.DateRangeFilter,
  },
  [FILTER_TYPE_DATE_MONTH]: {
    filterName: 'DateMonthFilter',
    filterClass: Filters.SelectFilter,
  },
  [FILTER_TYPE_DATE_MONTH_RANGE]: {
    filterName: 'DateMonthRangeFilter',
    filterClass: Filters.MonthRangeFilter,
  },
  [FILTER_TYPE_DATE_ONLY_RANGE]: {
    filterName: 'DateOnlyRangeFilter',
    filterClass: Filters.DateOnlyRangeFilter,
  },
  [FILTER_TYPE_HIERARCHY]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_HIERARCHY_MULTI_SELECT]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_MEDICATIONS]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_MULTI_SELECT]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_MULTI_SELECT_ASYNC]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_NUMBER]: {
    filterName: 'NumberFilter',
    filterClass: Filters.NumberFilter,
  },
  [FILTER_TYPE_NUMBER_RANGE]: {
    filterName: 'NumberRangeFilter',
    filterClass: Filters.NumberRangeFilter,
  },
  [FILTER_TYPE_ORGANIZATION]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_AGENS]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
  [FILTER_TYPE_RADIO]: {
    filterName: 'SelectFilter',
    filterClass: Filters.SelectFilter,
  },
  [FILTER_TYPE_RADIO_ENUM]: {
    filterName: 'SelectFilter',
    filterClass: Filters.SelectFilter,
  },
  [FILTER_TYPE_SELECT]: {
    filterName: 'SelectFilter',
    filterClass: Filters.SelectFilter,
  },
  [FILTER_TYPE_SELECT_ASYNC]: {
    filterName: 'SelectFilter',
    filterClass: Filters.SelectFilter,
  },
  [FILTER_TYPE_TEXT]: {
    filterName: 'TextFilter',
    filterClass: Filters.TextFilter,
  },
  [FILTER_TYPE_UNKNOWN]: {
    filterName: 'Filter',
    filterClass: Filters.Filter,
  },
  [FILTER_TYPE_SELECT_ENUM]: {
    filterName: 'SelectFilter',
    filterClass: Filters.SelectFilter,
  },
  [FILTER_TYPE_MULTI_SELECT_ENUM]: {
    filterName: 'MultiSelectFilter',
    filterClass: Filters.MultiSelectFilter,
  },
};

export class DynamicFilter {
  static getFilterClass(filterType) {
    let result;
    if (FiltersDefinitions[filterType]) {
      result = FiltersDefinitions[filterType].filterClass;
    } else {
      logger.warn(`Unrecognized filter type for DynamicFilter: ${filterType}`);
      result = FiltersDefinitions[FILTER_TYPE_UNKNOWN].filterClass;
    }
    return result;
  }

  static getFilterDefinition(filterType) {
    return FiltersDefinitions[filterType];
  }
}

export default {DynamicFilter};
